import { Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { AppContextService } from '../services/app-context.service';
import { of as observableOf, Observable } from 'rxjs';
import { GuardService } from '../services/guard/guard.service';

@Injectable({
	providedIn: 'root',
})
export class AuthSystemUserOrFinancierOnlyGuard {
	constructor(
		private router: Router,
		private appContext: AppContextService,
		private guardService: GuardService
	) {}

	//https://angular-2-training-book.rangle.io/routing/route_guards
	//https://stackoverflow.com/a/50277611
	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const loggedUser = this.guardService.checkPrivateAuthentication();

		if (
			!!loggedUser &&
			(loggedUser.IsSystemAdmin || loggedUser.IsFinancier || loggedUser.IsSupportOperator || loggedUser.IsBackOfficeOperator)
		) {
			return observableOf(true);
		} else if (!!loggedUser) {
			this.router.navigateByUrl('/private/home');

			return observableOf(true);
		} else {
			// if user is undefined or token has expired
			// reset app context and redirect to login page
			this.appContext.removeSession();
			this.router.navigateByUrl('/public/login');

			return observableOf(false);
		}
	}
}
